/**
 * Checks if the user has given consent for Google services.
 *
 * This function uses the SourcePoint consent management platform library
 * to determine if the user has granted consent for Google-related data processing.
 *
 * @returns {boolean}
 * True if consent has been granted for Google services, false otherwise.
 *
 * Returns undefined if the SourcePoint library is not available.
 *
 */
const isConsentedToGoogle = (): boolean => {
  return window?._sp_lib?.getConsentState(document.cookie)?.Google;
};

export default isConsentedToGoogle;
